// src/components/BestSeller.jsx
import React, { useContext } from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import { ShopContext } from '../context/ShopContext';
import ProductItem from './ProductItem';

const BestSeller = () => {
  const { products } = useContext(ShopContext);

  // Filter for best-selling products and take the first 4
  const bestSellerProducts = products.filter((product) => product.bestseller).slice(0, 4);

  return (
    <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
      <Container maxWidth="lg">
        {/* Section Title */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h4" component="h2" fontWeight="bold" gutterBottom>
            Our Best Sellers
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Discover the products our customers love the most.
          </Typography>
        </Box>

        {/* Products Grid */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(auto-fill, minmax(200px, 1fr))',
              sm: 'repeat(auto-fill, minmax(220px, 1fr))',
              md: 'repeat(4, 1fr)',
            },
            gap: 3,
          }}
        >
          {bestSellerProducts.map((product) => (
            <ProductItem key={product.id} product={product} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default BestSeller;
